import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isPosting: false,

  result: [],
};

const authLetterReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_LETTER_INFO_REQUEST:
        return {
            ...state,
            result: [],
            isFetching: true,
        };

    case types.GET_LETTER_INFO_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetching: false,
        };

    case types.GET_LETTER_INFO_FAILURE:
        return {
            ...state,
            result: [],
            isFetching: false,
        };

    default:
      return state;
  }
};

export default authLetterReducer;
